<emm-management-layout>
    <!--  <emm-progress-bar [isLoading]="rightLoading$ | async" progress-bar-right></emm-progress-bar>-->

    <emm-search-filter [attr.data-testid]="'master-menu_search_bar'"
                       [fields]="fields"
                       [addDialog]="true"
                       [showMenu]="true"
                       [isAdminOrAuthor]="this.isAdmin || this.isAuthor"
                       [isSuperAdmin]="this.isSuperAdmin"
                       (add)="openMenu($event)"
                       (addStandard)="onSelectStandard()"
                       (addCaptive)="onSelectCaptive()"
                       (filter)="onFilter($event)" layout-center-header>
    </emm-search-filter>


    <emm-generic-items-list [items]="allRevotes$ | async"
                            [contextMenuActions]="revoteContextMenuActions"
                            [isReadOnly]="isReadOnly$ | async"
                            (onSelectItem)="onSelectRevote($event)"
                            layout-center-content>
    </emm-generic-items-list>
    <emm-mms-revote-form #form layout-right-content></emm-mms-revote-form>
</emm-management-layout>
